var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_visible)?_c('div',{staticClass:"toast",class:_vm.colorClass},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('button',{staticClass:"close_button",attrs:{"id":`tracking__${_vm.trackingCode}__farm-screen__good-news__close`},on:{"click":_vm.toggleVisibility}},[_vm._v("×")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }